import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { User } from "@CommonApi/users/list";
import { editUserDataAtom } from "./atoms";

export const useEditUserModal = () => {
  const { openModal } = useModals();
  const setEditUserData = useSetAtom(editUserDataAtom);

  const openEditUserModal = (user: User) => {
    setEditUserData(user);
    openModal("EditUserModal");
  };

  return { openEditUserModal };
};
